import { Component  } from 'react';
import { axiosConfig, ValidateEmail, normalize } from "../../../config/utility";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import CreateIcon from "@material-ui/icons/Create";
import { connect } from "react-redux";

import { addSettings } from "../../../actions";
import {
  listSubClients,
  resendActivation,
  updateSubClient,
  listSubClientRights,
  addSubCLientRights,
  ListSubClientAssignRoles,
  editSubClientAssignRole,
  sendClientInvite,
  getClientInviteData,
  deleteInviteClient,
  getClientPermissionData,
  getRoleFieldSetting,
} from "./../../../config/client_api_calls";

import $ from "jquery";

import DataTableExtended from "../../../components/Tables/DataTableExtended";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import { tableLoaderListing } from "../../../components/ContentLoaders/table_loader_listing";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/FormLoader";
import DataTable from "../../../components/Tables/DataTable";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import { THEME_TEXT_COLOR, THEME_COLOR } from "./../../../config/config";
import MutextField from "@material-ui/core/TextField";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import { PhoneNumberUtil } from "google-libphonenumber";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import countryList from "react-select-country-list";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Tooltip from "@material-ui/core/Tooltip";
import dateFormat, { masks } from "dateformat";
import parsePhoneNumberFromString from "libphonenumber-js";
import PasswordStrengthBar from "react-password-strength-bar";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

const auth = new HelperClass();

class SubClients extends Component {
  constructor() {
    super();

    this.state = {
      tableData: [],
      serviceData: [],
      errorMessage: "",
      serviceId: "",
      successMessage: "",
      errorMessageEdit: "",
      successMessageEdit: "",
      errorMessageRights: "",
      successMessageRights: "",
      waitMessage: "",
      tableLoader: true,
      tableLoaderListing: true,
      activation_button: false,
      activation_tick: false,
      activation_cross: false,
      client_accountno: "",
      subclient_accountno: "",
      client_name: "",
      client_email: "",
      client_phone: "",
      client_address: "",
      client_address2: "",
      client_comp: "",
      client_title: "",
      // Role is a separate field from Title, shown only when the reseller
      // has enabled it in custom settings.
      client_role: "",
      role_field_enabled: false,
      client_city: "",
      client_state: "",
      client_zip: "",
      client_country: "",
      client_status: "",
      client_password: "",
      client_c_password: "",
      allRights: [],
      assignedMainRights: [],
      assignedSubRights: [],
      passwordShown: false,
      confirmPasswordShown: false,
      notifyCheckBox: false,
      errorMessageAgentRole: "",
      successMessageAgentRole: "",
      assignRoleData: [],
      assignSubRoleData: [],
      changedRolesRights: [],
      changedSubRolesRights: [],
      errorMessageSubClientRole: "",
      successMessageSubClientRole: "",
      subassignRoleData: [],
      subassignSubRoleData: [],
      subchangedRolesRights: [],
      subchangedSubRolesRights: [],
      checkedRoleIds: [],
      checkedSubRoleIds: [],
      checkedName: "",
      checkedEmail: "",

      errorName: "",
      errorClientStatus: "",
      errorClientCompany: "",
      errorClientEmail: "",
      errorClientPhone: "",
      errorClientAddress: "",
      errorClientCity: "",
      errorClientState: "",
      errorClientZip: "",
      errorClientCountry: "",
      errorClientPassword: "",
      errorCPassword: "",

      useGooglePlaces: true,
      toggleButtonText: "Allow PO Box Address",

      client_integration: "",
      va_integration: "",

      clientErrorMessage: "",
      clientSuccessMessage: "",
      client_name: "",
      client_email: "",
      invitation_comment: "",
      tableData_invitedClients: [],
      activeTabCP: "tabItem7",
      clientInviteErrorMessage: "",
      clientInviteSuccessMessage: "",

      address_autocomplete: true,
      address_validation: true,

      columnServices: [
        { name: "Name" },
        { name: "Company" },
        {
          name: "Phone",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.formatPhoneNumber(value)}</div>;
            },
          },
        },
        { name: "Email" },
        {
          name: "Date Added",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{auth.formatDateTime(value)}</div>;
            },
          },
        },
        {
          name: "Status",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.setStatus(value, tableMeta)}</div>;
            },
          },
        },
        { name: "ID", options: { display: "false" } },
        { name: "Address", options: { display: "false" } },
        { name: "Address2", options: { display: "false" } },
        { name: "Comp", options: { display: "false" } },
        { name: "City", options: { display: "false" } },
        { name: "State", options: { display: "false" } },
        { name: "Zip", options: { display: "false" } },
        { name: "Country", options: { display: "false" } },
        { name: "Title", options: { display: "false" } },
        { name: "VoiceAlerts Integration", options: { display: "false" } },
        {
          name: "VoiceAlerts Integration Permission",
          options: { display: "false" },
        },
        // Role is appended last in the API row and only shown when the
        // reseller has enabled the Role field.
        { name: "Role", options: { display: false, filter: false } },
        {
          name: "Actions",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div>
                  <div
                    className="nk-tb-col nk-tb-col-tools"
                    style={{ padding: "0px" }}
                  >
                    <ul className="nk-tb-actions gx-1">
                      <li>
                        <div className="drodown">
                          <a
                            href="#"
                            title="Other Actions"
                            className="dropdown-toggle btn btn-icon  btn-outline-light"
                            data-toggle="dropdown"
                          >
                            <em className="icon ni ni-more-h"></em>
                          </a>
                          <div className="dropdown-menu dropdown-menu-right">
                            <ul className="link-list-opt no-bdr">
                              <li>
                                <a
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    this.showDetails(value, tableMeta)
                                  }
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Service Details"
                                  disabled={
                                    this.props.is_msa_signed === "No" ||
                                    this.props.defaultSettings === "missing"
                                      ? true
                                      : false
                                  }
                                >
                                  <em className="icon ni ni-edit"></em>
                                  <span>Edit Sub User</span>
                                </a>
                              </li>
                              <li>
                                <a
                                  style={{ cursor: "pointer" }}
                                  data-toggle="tooltip"
                                  data-placement="left"
                                  onClick={() =>
                                    this.subclientAssignRole(value, tableMeta)
                                  }
                                  title="Assign Role"
                                  disabled={
                                    this.props.is_msa_signed === "No" ||
                                    this.props.defaultSettings === "missing"
                                      ? true
                                      : false
                                  }
                                >
                                  <em className="icon ni ni-grid-c"></em>
                                  <span>Assign Role</span>
                                </a>
                              </li>
                              {tableMeta.rowData[5] === "inactive" ? (
                                <li>
                                  <a
                                    data-toggle="tooltip"
                                    data-placement="left"
                                    onClick={() =>
                                      this.resendActivation(value, tableMeta)
                                    }
                                    title="Resend Activation"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <em className="icon ni ni-signin"></em>

                                    <span>Resend Activation</span>
                                  </a>
                                </li>
                              ) : null}
                            </ul>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              );
            },
          },
        },
      ],

      columnServices_invitedClients: [
        { name: "Name" },
        { name: "Email" },
        { name: "Agent Name" },
        { name: "Agent Email" },
        {
          name: "Invited On",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_date(value)}</div>;
            },
            filter: false,
          },
        },
        { name: "AGENT ID", options: { display: false } },
        { name: "ID", options: { display: false } },
        {
          name: "Comment",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div onClick={() => this.assignedTo(value, tableMeta)}>
                  <span
                    className="badge badge-outline-secondary"
                    style={{ cursor: "pointer" }}
                  >
                    View
                  </span>
                </div>
              );
            },
          },
        },
        {
          name: "Link",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              const rowId = tableMeta.rowData[6];
              const textToCopy = tableMeta.rowData[8];
              if (textToCopy && textToCopy.trim() !== "") {
                return (
                  <div
                    onClick={() => this.copyToClipboard(textToCopy, rowId)}
                    style={{ cursor: "pointer" }}
                  >
                    <span className="d-flex align-items-center">
                      <i
                        className={`icon ni ${
                          this.state.copiedRowId === rowId
                            ? "ni-check"
                            : "ni-copy"
                        }`}
                      ></i>
                      <span>
                        {this.state.copiedRowId === rowId ? "Copied" : "Copy"}
                      </span>
                    </span>
                  </div>
                );
              } else {
                return <div>---</div>;
              }
            },
          },
        },
        {
          name: "Actions",
          options: {
            customBodyRender: (value, tableMeta) => {
              return (
                <div>
                  <div
                    className="nk-tb-col nk-tb-col-tools"
                    style={{ padding: "0px" }}
                  >
                    <ul className="nk-tb-actions gx-1">
                      <li>
                        <div className="drodown">
                          <a
                            href="#"
                            className="dropdown-toggle btn btn-icon btn-outline-light"
                            data-toggle="dropdown"
                          >
                            <em className="icon ni ni-more-h"></em>
                          </a>
                          <div className="dropdown-menu dropdown-menu-right">
                            <ul className="link-list-opt no-bdr">
                              <li>
                                <a
                                  onClick={() =>
                                    this.deleteAlert(tableMeta.rowData[6])
                                  }
                                  style={{ cursor: "pointer" }}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Delete Agreement"
                                  disabled={
                                    this.props.is_msa_signed === "No" ||
                                    this.props.defaultSettings === "missing"
                                      ? true
                                      : false
                                  }
                                >
                                  <em className="icon ni ni-trash"></em>
                                  <span>Delete Client</span>
                                </a>
                              </li>
                              <li>
                                <a
                                  onClick={() =>
                                    this.resendInvite(
                                      tableMeta.rowData[1],
                                      tableMeta.rowData[0],
                                      tableMeta.rowData[7]
                                    )
                                  }
                                  style={{ cursor: "pointer" }}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Resend Activation"
                                  disabled={
                                    this.props.is_msa_signed === "No" ||
                                    this.props.defaultSettings === "missing"
                                      ? true
                                      : false
                                  }
                                >
                                  <em className="icon ni ni-signin"></em>
                                  <span>Resend Invite</span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              );
            },
          },
        },
      ],
    };
    this.countryOptions = countryList()
      .getData()
      .filter(
        (country) => country.label !== "United States Minor Outlying Islands"
      ).sort((a, b) => {
        if (a.label === "United States") return -1;
        if (b.label === "United States") return 1;
        return a.label.localeCompare(b.label);
      });
  }

  viewBtns = () => {
    if (
      this.props.is_msa_signed === "No" ||
      this.props.defaultSettings === "missing"
    ) {
      return <VisibilityOffIcon />;
    } else {
      return <VisibilityIcon style={{ cursor: "pointer" }} />;
    }
  };

  formatPhoneNumber = (phoneNumber) => {
    const phoneNumberObj = parsePhoneNumberFromString(phoneNumber);
    if (phoneNumberObj) {
      if (phoneNumberObj.country === "US") {
        const nationalNumber = phoneNumberObj
          .formatNational()
          .replace(/\D/g, ""); // e.g. "2123727200"
        const areaCode = nationalNumber.slice(0, 3);
        const firstPart = nationalNumber.slice(3, 6);
        const secondPart = nationalNumber.slice(6);
        return `(${areaCode}) ${firstPart}-${secondPart}`;
      }
      return phoneNumberObj.formatInternational();
    }
    return phoneNumber; // Return original number if parsing fails
  };

  subclientAssignRole = async (value, tableMeta) => {
    const agentId = tableMeta.rowData[6];
    const agentEmail = tableMeta.rowData[3];
    this.setState({
      errorMessageSubClientRole: "",
      successMessageSubClientRole: "",
      subassignRoleData: [],
      subassignSubRoleData: [],
      subchangedRolesRights: [],
      subchangedSubRolesRights: [],
      subclientRoleLoader: true,
      subdisableRoleBtn: false,
      subdisableSubRoleBtn: false,
      rolesSubClientName:
        tableMeta.rowData[0] + " (" + tableMeta.rowData[1] + ")",
      checkedName: tableMeta.rowData[0],
      checkedEmail: tableMeta.rowData[3],
    });
    window.$("#modalSubClientAssignRole").modal("show");
    this.getSubClientRoleData(agentId, agentEmail);
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      useGooglePlaces: !prevState.useGooglePlaces,
      toggleButtonText:
        prevState.toggleButtonText === "Allow PO Box Address"
          ? "Allow Simple Address"
          : "Allow PO Box Address",
    }));
  };

  getSubClientRoleData = async (agentId, agentEmail) => {
    const listSubClientAssignRoles = await ListSubClientAssignRoles(
      auth.getAccount(),
      auth.getToken(),
      agentId,
      agentEmail
    );

    // console.log("ListSubClientRoles Res: ", listSubClientAssignRoles.data.data);
    if (
      listSubClientAssignRoles.data.status === 403 ||
      listSubClientAssignRoles.data.errors === "authentication missing" ||
      listSubClientAssignRoles.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listSubClientAssignRoles.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      listSubClientAssignRoles.data.status === 200 &&
      listSubClientAssignRoles.data.message === "success"
    ) {
      const assignRoleData = listSubClientAssignRoles.data.data.roles;
      const assignSubRoleData = listSubClientAssignRoles.data.data.subroles;
      const allRoleData = listSubClientAssignRoles.data.data.Allroles.map(
        (role) => {
          const isActiveRole = assignRoleData.some(
            (assignedRole) =>
              assignedRole.alt === role.alt && assignedRole.isactive === 1
          );
          return {
            ...role,
            isChecked: isActiveRole,
          };
        }
      );

      const allSubRoleData = listSubClientAssignRoles.data.data.Allsubroles.map(
        (subRole) => {
          const isActiveSubRole = assignSubRoleData.some(
            (assignedSubRole) =>
              assignedSubRole.alt === subRole.alt &&
              assignedSubRole.isactive === 1
          );
          return {
            ...subRole,
            isChecked: isActiveSubRole,
          };
        }
      );

      this.setState({
        assignRoleData,
        assignSubRoleData,
        allRoleData,
        allSubRoleData,
        subclientRoleLoader: false,
      });

      const initialActiveRoles = assignRoleData
        .filter((role) => role.isactive === 1)
        .map((role) => ({
          alt: role.alt,
          isChecked: true,
        }));

      const initialActiveSubRoles = assignSubRoleData
        .filter((subRole) => subRole.isactive === 1)
        .map((subRole) => ({
          id: subRole.id,
          isChecked: true,
        }));

      this.setState({
        changedRolesRights: initialActiveRoles,
        changedSubRolesRights: initialActiveSubRoles,
      });
    } else {
      //window.location.replace("/error");
    }
  };

  changedAllRolesRights = (event) => {
    const { name, checked } = event.target;

    // Update checkedRoleIds in the state
    const { checkedRoleIds } = this.state;
    const updatedCheckedRoleIds = checked
      ? [...checkedRoleIds, name] // add ID if checked
      : checkedRoleIds.filter((id) => id !== name); // remove ID if unchecked

    this.setState({ checkedRoleIds: updatedCheckedRoleIds });

    // Update allRoleData with isChecked property
    const { allRoleData, allSubRoleData } = this.state;
    const updatedAllRoleData = allRoleData.map((role) => {
      if (role.id.toString() === name) {
        return {
          ...role,
          isChecked: checked,
        };
      }
      return role;
    });

    // Update associated sub roles
    const updatedAllSubRoleData = allSubRoleData.map((subRole) => {
      if (subRole.role_id.toString() === name) {
        return {
          ...subRole,
          isChecked: checked,
        };
      }
      return subRole;
    });

    this.setState({
      allRoleData: updatedAllRoleData,
      allSubRoleData: updatedAllSubRoleData,
    });
  };

  changedAllSubRolesRights = (event) => {
    const { name, checked } = event.target;

    // Update checkedSubRoleIds in the state
    const { checkedSubRoleIds } = this.state;
    const updatedCheckedSubRoleIds = checked
      ? [...checkedSubRoleIds, name] // add ID if checked
      : checkedSubRoleIds.filter((id) => id !== name); // remove ID if unchecked

    this.setState({ checkedSubRoleIds: updatedCheckedSubRoleIds });

    // Update allSubRoleData with isChecked property
    const { allSubRoleData } = this.state;
    const updatedAllSubRoleData = allSubRoleData.map((subRole) => {
      if (subRole.tabdetailid.toString() === name) {
        return {
          ...subRole,
          isChecked: checked,
        };
      }
      return subRole;
    });

    this.setState({ allSubRoleData: updatedAllSubRoleData });
  };

  handleSubmitRoleCheckboxSub = async (name, email) => {
    this.setState({
      errorMessageSubClientRole: "",
      successMessageSubClientRole: "",
      subdisableRoleBtn: true,
    });

    const { allRoleData, allSubRoleData } = this.state;

    const CheckRoleFields = allRoleData.map((role) => ({
      id: role.id,
      isactive: role.isChecked ? 1 : 0,
    }));

    const CheckSubRoleFields = allSubRoleData.map((role) => ({
      id: role.tabdetailid,
      isactive: role.isChecked ? 1 : 0,
    }));

    const saveResponce = await editSubClientAssignRole(
      auth.getAccount(),
      auth.getToken(),
      CheckRoleFields,
      CheckSubRoleFields,
      name,
      email
    );

    if (
      saveResponce.data.status === 403 ||
      saveResponce.data.errors === "authentication missing" ||
      saveResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (saveResponce.data.status === 404) {
      // window.location.replace("/error");
      this.setState({
        errorMessageSubClientRole:
          "There is some error while updating the Sub User Role.",
        successMessageSubClientRole: "",
        subdisableRoleBtn: false,
      });
    } else if (
      saveResponce.data.status === 200 &&
      saveResponce.data.message === "success"
    ) {
      this.setState({
        errorMessageSubClientRole: "",
        successMessageSubClientRole: "Sub User Role updated successfully.",
        subdisableRoleBtn: false,
      });
      setTimeout(() => {
        //this.props.props.history.push("/agent_roles");
        window.$("#modalSubClientAssignRole").modal("hide");
      }, 3000);
    } else {
      this.setState({
        errorMessageSubClientRole: saveResponce.data.message,
        successMessageSubClientRole: "",
        subdisableRoleBtn: false,
      });
      //window.location.replace("/error");
    }
  };

  setStatus = (value, tableMeta) => {
    let domain_str = tableMeta.rowData[5];
    //console.log("domain_str: ", domain_str);
    if (domain_str === "active") {
      return (
        <div>
          <span className="badge badge-outline-secondary">
            {" "}
            <em className="icon ni ni-done" title="Active"></em> Active
          </span>
        </div>
      );
    } else {
      return (
        <div>
          <span className="badge badge-outline-danger">
            {" "}
            <em className="icon ni ni-alert-c"></em> Inactive
          </span>
        </div>
      );
    }
  };

  defaultText = (value, tableMeta) => {
    //console.log("tableMeta.rowData: ", tableMeta.rowData[9]);
    let is_default = tableMeta.rowData[5];
    if (is_default === "No") {
      return (
        <a
          style={{ cursor: "pointer" }}
          onClick={() => this.setDefaultService(value, tableMeta)}
          disabled={
            this.props.is_msa_signed === "No" ||
            this.props.defaultSettings === "missing"
              ? true
              : false
          }
        >
          <span className="badge badge-outline-primary">
            <em className="icon ni ni-signin"></em> Make Default
          </span>
        </a>
      );
    } else {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Yes
        </span>
      );
    }
  };

  defaultMarketing = (value, tableMeta) => {
    //console.log("tableMeta.rowData: ", tableMeta.rowData[9]);
    let is_default = value.split("###");
    let marketing_content = is_default[0];
    let marketing_link = is_default[1];
    if (marketing_content === "link") {
      return (
        <a href={marketing_link} terget="_blank">
          <span className="badge badge-outline-primary">
            <em className="icon ni ni-signin"></em> Product Info
          </span>
        </a>
      );
    } else if (marketing_content === "pdf") {
      return (
        <a href={marketing_link} terget="_blank">
          <span className="badge badge-outline-primary">
            <em className="icon ni ni-download"></em> View PDF
          </span>
        </a>
      );
    } else {
      return "";
    }
  };

  async componentDidMount() {
    const servicesResponce = await listSubClients(
      auth.getClientAccount(),
      auth.getClientToken()
    );
    // console.log("Available Sub Clients: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
      });
    } else if (servicesResponce.data.status === 200) {
      this.setState({
        tableData: servicesResponce.data.data,
        tableLoader: false,
        tableLoaderListing: false,
      });
    } else {
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
      });
      //window.location.replace("/error");
    }
    await this.getClientPermissionData();
    await this.loadRoleFieldSetting();
  }

  loadRoleFieldSetting = async () => {
    let enabled = false;
    try {
      const res = await getRoleFieldSetting(
        auth.getClientAccount(),
        auth.getClientToken()
      );
      enabled = res && res.data && res.data.role_field_enabled ? true : false;
    } catch (error) {
      enabled = false;
    }
    // The Role column is last in the row data; reveal it in place and let
    // columnOrder move it next to the other visible columns.
    this.setState((prevState) => ({
      role_field_enabled: enabled,
      columnServices: prevState.columnServices.map((col) =>
        col.name === "Role"
          ? { ...col, options: { ...col.options, display: enabled } }
          : col
      ),
    }));
  };

  getClientPermissionData = async () => {
    let acctno = auth.getClientAccount();

    let res = await getClientPermissionData(
      acctno,
      auth.getClientToken(),
      auth.getEmailClient()
    );
    //console.log("getClientPermissionData: ", res.data);
    if (res.data.status === 200 && res.data.message === "success") {
      const permissionData = res.data.clientPermissionSettingsInfo?.data || {};
      this.setState({
        address_autocomplete: permissionData.address_autocomplete,
        address_validation: permissionData.address_validation,
      });
    }
  };

  setMarkUp = async (value, tableMeta) => {
    let service_id = tableMeta.rowData[0];

    window.$("#modalForm").modal("show");
  };

  format_date = (value, tableMeta) => {
    let date = value;
    return dateFormat(date, "mm-dd-yyyy, h:MM:ss TT");
  };

  /*formatPhoneNumber = (value, tableMeta) => {
    const cleaned = ("" + value).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return value;
  };*/

  phoneUtil = PhoneNumberUtil.getInstance();

  isPhoneValid = (phone) => {
    try {
      return this.phoneUtil.isValidNumber(
        this.phoneUtil.parseAndKeepRawInput(phone)
      );
    } catch (error) {
      return false;
    }
  };

  handleAddressSelect = async (place) => {
    const { description } = place.value;
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          description
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`
      );
      const data = await response.json();

      if (data.status === "OK") {
        const addressComponents = data.results[0].address_components;
        const formattedAddress = data.results[0].formatted_address;
        let city = null;
        let state = null;
        let country = null;
        let zipCode = null;
        let streetAddress = "";
        let neighborhood = null;
        let locality = null;
        let address2 = "";
        addressComponents.forEach((component) => {
          if (component.types.includes("neighborhood")) {
            neighborhood = component.long_name;
          } else if (component.types.includes("locality")) {
            locality = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          } else if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (component.types.includes("subpremise")) {
            address2 = component.long_name;
          } else if (
            ![
              "neighborhood",
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "postal_code_suffix",
            ].includes(component.types[0])
          ) {
            if (streetAddress !== "") {
              streetAddress += " ";
            }
            streetAddress += component.long_name;
          }
        });
        // Check if neighborhood is part of the formatted address
        if (neighborhood && formattedAddress.includes(neighborhood)) {
          city = neighborhood;
        } else {
          city = locality;
        }
        this.setState({
          client_city: city && city !== "" ? city : "",
          client_state: state && state !== "" ? state : "",
          client_zip: zipCode && zipCode !== "" ? zipCode : "",
          client_country: country && country !== "" ? country : "",
          client_address:
            streetAddress && streetAddress !== "" ? streetAddress : "",
          client_address2: address2 && address2 !== "" ? address2 : "",
        });
      } else {
        console.error("Reverse geocoding request failed:", data.status);
      }
    } catch (error) {
      console.error("Error fetching reverse geocoding data:", error);
    }
  };

  handleChangeCountry = (event) => {
    // console.log("event.label: ", event.label);
    const country = event.label;
    this.setState({
      client_country: country,
    });
  };

  resendActivation = async (value, tableMeta) => {
    let client_accountno = tableMeta.rowData[6];
    this.setState({
      activation_button: true,
      activation_tick: false,
      activation_cross: false,
    });
    window.$("#modalAlertResend").modal("show");
    const kycResponce = await resendActivation(
      auth.getClientAccount(),
      auth.getClientToken(),
      client_accountno
    );
    //console.log("resendActivation: ", kycResponce.data);
    if (
      kycResponce.data.status === 403 ||
      kycResponce.data.errors === "authentication missing" ||
      kycResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (kycResponce.data.status === 406) {
      this.setState({
        activation_button: false,
        activation_tick: false,
        activation_cross: true,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 404 &&
      kycResponce.data.message === "not_found"
    ) {
      this.setState({
        activation_button: false,
        activation_tick: false,
        activation_cross: true,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 200 &&
      kycResponce.data.message === "success"
    ) {
      this.setState({
        activation_button: false,
        activation_tick: true,
        activation_cross: false,
      });
    } else {
      this.setState({
        activation_button: false,
        activation_tick: false,
        activation_cross: true,
      });
    }
    setTimeout(() => {
      this.setState({
        activation_button: false,
        activation_tick: false,
        activation_cross: false,
      });
      window.$("#modalAlertResend").modal("hide");
    }, 4000);
  };

  showDetails = async (value, tableMeta) => {
    let client_accountno = tableMeta.rowData[6];
    let client_name = tableMeta.rowData[0];
    let client_email = tableMeta.rowData[3];
    let client_phone = tableMeta.rowData[2];
    let client_status = tableMeta.rowData[5];
    let client_address = tableMeta.rowData[7];
    let client_address2 = tableMeta.rowData[8];
    let client_comp = tableMeta.rowData[9];
    let client_city = tableMeta.rowData[10];
    let client_state = tableMeta.rowData[11];
    let client_zip = tableMeta.rowData[12];
    let client_country = tableMeta.rowData[13];
    let client_title = tableMeta.rowData[14];
    let client_integration = tableMeta.rowData[15];
    let va_integration = tableMeta.rowData[16];

    this.setState({
      client_accountno: client_accountno,
      client_name: client_name,
      client_email: client_email,
      client_phone: client_phone,
      client_status: client_status,
      client_address: client_address,
      client_address2: client_address2,
      client_comp: client_comp,
      client_city: client_city,
      client_state: client_state,
      client_zip: client_zip,
      client_country: client_country,
      client_title: client_title,
      // Role is a separate field from Title; last index in the API row.
      client_role: tableMeta.rowData[17] || "",
      client_integration: client_integration,
      va_integration: va_integration,
      client_password: "",
    });

    window.$("#modalFormDetail").modal("show");
  };

  client_rights = async (value, tableMeta) => {
    // console.log("client_rights: ", value);
    this.setState({
      tableLoaderListing: true,
    });
    window.$("#modalFormRights").modal("show");
    const servicesResponce = await listSubClientRights(
      auth.getClientAccount(),
      auth.getClientToken(),
      value
    );
    // console.log("Client Rights Data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
      this.setState({
        tableLoaderListing: false,
        errorMessageRights: "There is some error while getting the rights.",
      });
    } else if (servicesResponce.data.status === 200) {
      this.setState({
        subclient_accountno: value,
        allRights: servicesResponce.data.allRights,
        assignedMainRights: servicesResponce.data.assignedMainRights,
        assignedSubRights: servicesResponce.data.assignedSubRights,
        tableLoaderListing: false,
      });
    } else {
      this.setState({
        tableLoaderListing: false,
        errorMessageRights: "There is some error while getting the rights.",
      });
      //window.location.replace("/error");
    }
  };

  formSaveRights = async () => {
    let { client_accountno, client_parent, subclient_accountno } = this.state;
    var sub_selected_menus = [];
    var main_selected_menus = $("input:checkbox.vdrSelected:checked")
      .map(function () {
        sub_selected_menus = $(
          "input:checkbox.vdrSelectedSub" + this.value + ":checked"
        )
          .map(function () {
            return this.value;
          })
          .get();
        // console.log("sub_selected_menus: ", sub_selected_menus);
        let insideArray = {
          main_id: this.value,
          subclient_accountno: subclient_accountno,
          submenus: sub_selected_menus,
        };
        return insideArray;
      })
      .get();

    // console.log("main_selected_services: ", main_selected_menus);

    const servicesResponce = await addSubCLientRights(
      auth.getClientAccount(),
      auth.getClientToken(),
      subclient_accountno,
      JSON.stringify(main_selected_menus)
    );
    // console.log("Add Rights Result: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "client_not_found"
    ) {
      //window.location.replace("/error");
      this.setState({
        successMessageRights: "",
        disabled: false,
        errorMessageRights: "Sub user not found.",
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        successMessageRights: "Rights added successfully.",
        errorMessageRights: "",
        disabled: false,
      });
    } else {
      this.setState({
        successMessageRights: "",
        disabled: false,
        errorMessageRights: "There is some error while adding the rights.",
      });
    }
    setTimeout(() => {
      this.setState({
        successMessageRights: "",
        disabled: false,
        errorMessageRights: "",
      });
    }, 4000);
  };

  phoneUtil = PhoneNumberUtil.getInstance();

  isPhoneValid = (phone) => {
    try {
      return this.phoneUtil.isValidNumber(
        this.phoneUtil.parseAndKeepRawInput(phone)
      );
    } catch (error) {
      return false;
    }
  };

  formUpdateSubmit = async () => {
    let {
      client_title,
      client_name,
      client_email,
      client_password,
      client_c_password,
      client_phone,
      client_accountno,
      client_comp,
      client_city,
      client_state,
      client_zip,
      client_address,
      client_address2,
      client_country,
      client_status,
      client_integration,
    } = this.state;
    this.setState({
      successMessageEdit: "",
      errorMessageEdit: "",
      errorName: "",
      errorClientStatus: "",
      errorClientCompany: "",
      errorClientEmail: "",
      errorClientPhone: "",
      errorClientAddress: "",
      errorClientCity: "",
      errorClientState: "",
      errorClientZip: "",
      errorClientCountry: "",
      errorClientPassword: "",
      errorCPassword: "",
    });
    const modalBody = document.getElementById("modalFormDetail");
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (modalBody) {
      setTimeout(() => {
        modalBody.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 0);
    }

    let is_validated = true;
    if (client_name === "") {
      this.setState({
        errorName: "error",
        errorMessageEdit: "Sub User Name is required.",
      });
      is_validated = false;
    } else if (client_comp === "") {
      this.setState({
        errorName: "",
        errorClientCompany: "error",
        errorMessageEdit: "Company is required.",
      });
      is_validated = false;
    } else if (client_phone === "") {
      this.setState({
        errorClientCompany: "",
        errorClientPhone: "error",
        errorMessageEdit: "Phone is required.",
      });
      is_validated = false;
    } else if (!this.isPhoneValid(this.state.client_phone)) {
      this.setState({
        errorClientCompany: "",
        errorClientPhone: "error",
        errorMessageEdit: "Invalid phone format.",
      });
      is_validated = false;
    } else if (this.state.client_address === "") {
      this.setState({
        errorClientPhone: "",
        errorClientAddress: "error",
        errorMessageEdit: "Address is required.",
      });
      is_validated = false;
    } else if (this.state.client_city === "") {
      this.setState({
        errorClientAddress: "",
        errorClientCity: "error",
        errorMessageEdit: "City is required.",
      });
      is_validated = false;
    } else if (this.state.client_state === "") {
      this.setState({
        errorClientCity: "",
        errorClientState: "error",
        errorMessageEdit: "State is required.",
      });
      is_validated = false;
    } else if (this.state.client_zip === "") {
      this.setState({
        errorClientState: "",
        errorClientZip: "error",
        errorMessageEdit: "Zip is required.",
      });
      is_validated = false;
    } else if (this.state.client_country === "") {
      this.setState({
        errorClientZip: "",
        errorClientCountry: "error",
        errorMessageEdit: "Country is required.",
      });
      is_validated = false;
    } else if (client_password !== "") {
      if (client_password.length < 8) {
        this.setState({
          errorClientCountry: "",
          errorClientPassword: "error",
          errorMessageEdit: "Use 8 characters or more for your password",
        });
        is_validated = false;
      } else if (!passwordRegex.test(client_password)) {
        this.setState({
          errorClientCountry: "",
          errorClientPassword: "error",
          errorMessageEdit:
            "Password must be at least 8 characters, with uppercase, lowercase, number & special character.",
        });
        is_validated = false;
      } else if (client_c_password === "") {
        this.setState({
          errorClientPassword: "",
          errorCPassword: "error",
          errorMessageEdit: "Confirm password is required.",
        });
        is_validated = false;
      } else if (client_c_password.length < 8) {
        this.setState({
          errorClientPassword: "",
          errorCPassword: "error",
          errorMessageEdit:
            "Use 8 characters or more for your confirm password",
        });
        is_validated = false;
      } else if (client_password.trim() !== client_c_password.trim()) {
        this.setState({
          errorClientPassword: "",
          errorCPassword: "error",
          errorMessageEdit: "Password and confirm password do not match.",
        });
        is_validated = false;
      }
    }
    if (is_validated) {
      let apiResponce = await updateSubClient(
        auth.getClientAccount(),
        auth.getClientToken(),
        client_name,
        client_title,
        client_email,
        client_password,
        client_phone,
        client_accountno,
        client_address,
        client_address2,
        client_zip,
        client_country,
        client_city,
        client_state,
        client_comp,
        client_status,
        this.state.notifyCheckBox.toString(),
        client_integration,
        this.state.client_role
      );

      // Check the response correctly
      if (
        apiResponce.data.status === 403 ||
        apiResponce.data.errors === "authentication missing" ||
        apiResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        apiResponce.data.status === 409 &&
        apiResponce.data.message === "Address validation failed"
      ) {
        const formattedErrorMessage = apiResponce.data.errors
          ? String(apiResponce.data.errors).replace(/,/g, "<br />")
          : "Address validation failed";
        this.setState({
          errorMessageEdit: formattedErrorMessage,
          disabled: false,
        });
      } else if (
        apiResponce.data.status === 200 &&
        apiResponce.data.message === "Success"
      ) {
        this.setState({
          successMessageEdit: "Sub user updated successfully.",
          tableLoader: false,
        });
      } else if (
        apiResponce.data.status === 404 &&
        apiResponce.data.message === "already_exists"
      ) {
        this.setState({
          errorMessageEdit:
            "Email already exists. Please try a different email address.",
          disabled: false,
          tableLoader: false,
        });
        return false;
      } else if (
        apiResponce.data.status === 404 &&
        apiResponce.data.message === "fail"
      ) {
        this.setState({
          errorMessageEdit: "Something went wrong, try again later.",
          disabled: false,
          tableLoader: false,
        });
        return false;
      } else {
        this.setState({
          errorMessageEdit: "Something went wrong, try again later.",
          disabled: false,
          tableLoader: false,
        });
      }
    }

    setTimeout(() => {
      this.setState({
        errorMessageEdit: "",
        successMessageEdit: "",
      });
    }, 5000);
  };

  handleChange = async (event) => {
    const { target } = event;
    let value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    if (name === "client_name") {
      value = value.replace(/[^a-zA-Z\s'.,\-:()|!@]/g, "");
    } else if (name === "client_title") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    } else if (name === "client_comp") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    }
    this.setState({
      [name]: value,
    });
  };

  calculatePercent = (percent, num) => {
    return (percent / 100) * num;
  };
  modalHide = () => {
    window.$("#modalFormDetail").modal("hide");
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(
      "/" + auth.getResellerRegToken() + "/" + link
    );
  };

  togglePassword = () => {
    this.setState({
      passwordShown: !this.state.passwordShown,
    });
  };

  toggleConfirmPassword = () => {
    this.setState({
      confirmPasswordShown: !this.state.confirmPasswordShown,
    });
  };

  setNewClientSettings = async () => {
    this.setState({
      clientErrorMessage: "",
      clientSuccessMessage: "",
      client_name: "",
      client_email: "",
      invitation_comment: "",
    });
    window.$("#modalAddNewClient").modal("show");
  };

  saveNewClient = async () => {
    const { client_name, client_email, invitation_comment } = this.state;
    this.setState({
      clientErrorMessage: "",
      clientSuccessMessage: "",
      disabled: true,
    });

    if (client_name === "") {
      this.setState({
        clientErrorMessage: "Please enter the name.",
        clientSuccessMessage: "",
        disabled: false,
      });
    } else if (client_email === "") {
      this.setState({
        clientErrorMessage: "Please enter the email address.",
        clientSuccessMessage: "",
        disabled: false,
      });
    } else if (ValidateEmail(client_email) === false) {
      this.setState({
        clientErrorMessage: "Please enter the valid email address.",
        clientSuccessMessage: "",
        disabled: false,
      });
    } else if (invitation_comment === "") {
      this.setState({
        clientErrorMessage: "Please enter the comment.",
        clientSuccessMessage: "",
        disabled: false,
      });
    } else {
      const servicesResponce = await sendClientInvite(
        auth.getClientAccount(),
        auth.getClientToken(),
        client_email,
        client_name,
        invitation_comment
      );

      // console.log("agentsResponce.data.data: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (servicesResponce.data.status === 409) {
        this.setState({
          clientErrorMessage:
            "An account with this email already exists. Invitation not sent.",
          clientSuccessMessage: "",
          disabled: false,
        });
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          clientErrorMessage:
            "There is some error while sending invite to the sub user.",
          clientSuccessMessage: "",
          disabled: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          clientErrorMessage: "",
          clientSuccessMessage: "Invite successfully sent to the sub user.",
          disabled: false,
          client_email: "",
          client_name: "",
          invitation_comment: "",
          tableData_invitedClients: servicesResponce.data.invited_clients,
        });
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        this.setState({
          clientErrorMessage:
            "There is some error while sending invite to the sub user.",
          clientSuccessMessage: "",
          disabled: false,
        });
      }
    }
    setTimeout(() => {
      this.setState({
        clientErrorMessage: "",
        clientSuccessMessage: "",
      });
    }, 4000);
  };

  resendInvite = async (client_email, client_name, invitation_comment) => {
    this.setState({
      clientInviteErrorMessage: "",
      clientInviteSuccessMessage: "",
      disabled: true,
    });

    const servicesResponce = await sendClientInvite(
      auth.getClientAccount(),
      auth.getClientToken(),
      client_email,
      client_name,
      invitation_comment
    );

    window.$("#modalresendInvitation").modal("show");

    // console.log("agentsResponce.data.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 409) {
      this.setState({
        clientErrorMessage:
          "An account with this email already exists. Invitation not sent.",
        clientSuccessMessage: "",
        disabled: false,
      });
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        clientInviteErrorMessage: "Error sending invitation email.",
        clientInviteSuccessMessage: "",
        disabled: false,
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState(
        {
          clientInviteErrorMessage: "",
          clientInviteSuccessMessage: "Invitation email sent successfully.",
          disabled: false,
        },
        () => {
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        }
      );
    } else {
      this.setState({
        clientInviteErrorMessage: "Error Sending Activation Email",
        clientInviteSuccessMessage: "",
        disabled: false,
      });
    }
  };

  modalHideResend = () => {
    window.$("#modalresendInvitation").modal("hide");
  };

  handleTabClick = (tabId) => {
    this.setState({ activeTabCP: tabId });
  };

  assignedTo = (value, tableMeta) => {
    let invitation_comment = tableMeta.rowData[7];
    this.setState(
      {
        invitation_comment: invitation_comment,
      },
      () => {
        window.$("#modalInvitationComment").modal("show");
      }
    );
  };

  getInviteData = async () => {
    const servicesResponce = await getClientInviteData(
      auth.getClientAccount(),
      auth.getClientToken()
    );
    // console.log("Available Sub Users: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
      });
    } else if (servicesResponce.data.status === 200) {
      this.setState({
        tableData_invitedClients: servicesResponce.data.invited_clients,
        tableLoader: false,
        tableLoaderListing: false,
      });
    } else {
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
      });
    }
  };

  deleteAlert = async (value) => {
    //console.log("tableMeta.rowData: ", tableMeta.rowData[9]);
    let id = value;
    this.setState({
      delete_id: id,
    });
    window.$("#modalDeleteAlert").modal("show");
  };

  modalHideDel = () => {
    window.$("#modalDeleteAlert").modal("hide");
  };

  deleteInviteClient = async () => {
    let client_id = this.state.delete_id;

    this.setState({
      clientInviteErrorMessage: "",
      clientInviteSuccessMessage: "",
      disabled: true,
    });

    const userResponce = await deleteInviteClient(
      auth.getClientAccount(),
      auth.getClientToken(),
      client_id
    );

    // console.log("deleteClientInvite: ", userResponce.data);

    if (
      userResponce.data.status === 403 ||
      userResponce.data.errors === "authentication missing" ||
      userResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      userResponce.data.status === 404 &&
      userResponce.data.message === "fail" &&
      userResponce.data.note !== ""
    ) {
      this.setState({
        clientInviteErrorMessage: "Error deleting the invited sub client.",
        clientInviteSuccessMessage: "",
        disabled: false,
      });
    } else if (
      userResponce.data.status === 200 &&
      userResponce.data.message === "success"
    ) {
      this.setState({
        clientInviteErrorMessage: "",
        clientInviteSuccessMessage: "Invited Sub Client deleted successfully.",
        disabled: false,
      });

      setTimeout(function () {
        window.location.reload();
        window.$("#modalDeleteAlert").modal("hide");
      }, 3000);
    } else {
      this.setState({
        clientInviteErrorMessage: "Error deleting the invited sub client.",
        clientInviteSuccessMessage: "",
        disabled: false,
      });
    }
  };

  copyToClipboard = (text, rowId) => {
    navigator.clipboard.writeText(text);
    this.setState({ copiedRowId: rowId });
    setTimeout(() => {
      this.setState({ copiedRowId: null });
    }, 3000);
  };

  render() {
    const { useGooglePlaces, toggleButtonText } = this.state;
    //$(".nk-block .MUIDataTable-paper-2").css("padding", "10px");
    return (
      <div className="nk-content " id="SubClients_Block">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" &&
          this.props.from !== "dashboard" ? (
            <SettingsError />
          ) : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" &&
          this.props.from !== "dashboard" ? (
            <MsaWarning />
          ) : null}

          {/* MSA WARNING END */}

          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE TITLE START */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <PageTitle name="Sub Users" icon="icon ni ni-user-list" />
                    </h3>
                  </div>
                  {auth.getUserTypeClient() === "Super" ? (
                    <>
                      <div className="nk-block-head-content" id="HeadContent">
                        <div className="toggle-wrap nk-block-tools-toggle">
                          <a
                            href="#"
                            className="btn btn-icon btn-trigger toggle-expand mr-n1"
                            data-target="pageMenu"
                          >
                            <em className="icon ni ni-more-v"></em>
                          </a>
                          <div
                            className="toggle-expand-content"
                            data-content="pageMenu"
                          >
                            <ul className="nk-block-tools g-3">
                              <li className="nk-block-tools-opt">
                                <a
                                  onClick={() => this.setNewClientSettings()}
                                  className="btn btn-primary"
                                  style={{ color: "white" }}
                                >
                                  <em className="icon ni ni-plus-round"></em>
                                  &nbsp;Invite New Sub User
                                </a>
                              </li>
                              <li className="nk-block-tools-opt">
                                {this.props.defaultSettings !== "missing" ? (
                                  <a
                                    onClick={() =>
                                      this.addMenuHistory(
                                        "client/SubClients/AddSubClient"
                                      )
                                    }
                                    style={{
                                      color: "#fff",
                                    }}
                                    className="btn btn-primary"
                                  >
                                    <em className="icon ni ni-plus-round"></em>
                                    <span>Add New Sub User</span>
                                  </a>
                                ) : null}
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              {/* PAGE TITLE END */}
              <div className="nk-block">
                <div className="row g-gs">
                  <div className="col-xxl-12">
                    <div className="row g-gs" style={{ clear: "both" }}>
                      <div className="col-lg-12">
                        <div
                          className="card card-bordered"
                          style={{ clear: "both" }}
                        >
                          <div className="card-inner">
                            <ul className="nav nav-tabs">
                              <li className="nav-item">
                                <a
                                  className={`nav-link ${
                                    this.state.activeTabCP === "tabItem7"
                                      ? "active"
                                      : ""
                                  }`}
                                  data-toggle="tab"
                                  href="#tabItem7"
                                  onClick={() =>
                                    this.handleTabClick("tabItem7")
                                  }
                                >
                                  <em className="icon ni ni-user-list"></em>
                                  <span>All Sub Users</span>
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  className={`nav-link ${
                                    this.state.activeTabCP === "tabItem8"
                                      ? "active"
                                      : ""
                                  }`}
                                  data-toggle="tab"
                                  href="#tabItem8"
                                  onClick={() => {
                                    this.handleTabClick("tabItem8");
                                    this.getInviteData();
                                  }}
                                >
                                  <em className="icon ni ni-user-add"></em>
                                  <span>Pending Invitations</span>
                                </a>
                              </li>
                            </ul>
                            <div className="tab-content" style={{ marginTop: 0 }}>
                              <div
                                className={`tab-pane ${
                                  this.state.activeTabCP === "tabItem7"
                                    ? "active"
                                    : ""
                                }`}
                                id="tabItem7"
                              >
                                <div className="row">
                                  <div className="col-md-12">
                                    {this.state.tableLoader === true ? (
                                      tableLoader()
                                    ) : (
                                      <DataTable
                                        columns={this.state.columnServices}
                                        tableData={this.state.tableData}
                                        title="All Sub Users"
                                        options={
                                          this.state.role_field_enabled
                                            ? {
                                                columnOrder: [
                                                  0, 1, 2, 3, 17, 4, 5, 6, 7,
                                                  8, 9, 10, 11, 12, 13, 14, 15,
                                                  16, 18,
                                                ],
                                              }
                                            : {}
                                        }
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div
                                className={`tab-pane ${
                                  this.state.activeTabCP === "tabItem8"
                                    ? "active"
                                    : ""
                                }`}
                                id="tabItem8"
                              >
                                <div className="row">
                                  <div className="col-md-12">
                                    {this.state.tableLoader === true ? (
                                      tableLoader()
                                    ) : (
                                      <DataTable
                                        columns={
                                          this.state
                                            .columnServices_invitedClients
                                        }
                                        tableData={
                                          this.state.tableData_invitedClients
                                        }
                                        title="Pending Invitations"
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal fade" tabIndex="-1" id="modalAlertResend">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <a href="#" className="close" data-dismiss="modal">
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        {this.state.activation_button === true ? (
                          <>
                            <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-check bg-warning"></em>
                            <h4 className="nk-modal-title">Sending!</h4>
                            <div className="nk-modal-text">
                              <div className="caption-text">
                                Please wait while we are processing your request
                              </div>
                              <span className="sub-text-sm"></span>
                            </div>
                            <div className="nk-modal-action"></div>
                          </>
                        ) : null}
                        {this.state.activation_tick === true ? (
                          <>
                            <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-check bg-success"></em>
                            <h4 className="nk-modal-title">Congratulations!</h4>
                            <div className="nk-modal-text">
                              <div className="caption-text">
                                Activation email has been sent successfully.
                              </div>
                              <span className="sub-text-sm"></span>
                            </div>
                            <div className="nk-modal-action"></div>
                          </>
                        ) : null}
                        {this.state.activation_cross === true ? (
                          <>
                            <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></em>
                            <h4 className="nk-modal-title">Oops!</h4>
                            <div className="nk-modal-text">
                              <div className="caption-text">
                                There is some error while sending activation
                                email. Please try again later
                              </div>
                              <span className="sub-text-sm"></span>
                            </div>
                            <div className="nk-modal-action"></div>
                          </>
                        ) : null}
                      </div>
                    </div>
                    <div className="modal-footer bg-lighter">
                      <div className="text-center w-100">
                        <a
                          href="#"
                          className="btn btn-lg btn-mw btn-primary"
                          data-dismiss="modal"
                        >
                          Close
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* ACTIVATION MODAL END */}

              {/* New Client Modal Start */}
              <div className="modal fade" tabIndex="-1" id="modalAddNewClient">
                <div
                  className="modal-dialog modal-dialog-top modal-xl"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">
                        <em
                          className="icon ni ni-user-add"
                          style={{ marginRight: "5px" }}
                        ></em>{" "}
                        Invite New Sub User
                      </h5>
                    </div>
                    <div className="modal-body">
                      {this.state.formLoader === true ? (
                        FormLoader()
                      ) : (
                        <div className="row g-4">
                          {this.state.clientErrorMessage !== "" ? (
                            <div className="col-md-12 mb-3">
                              <div
                                className="example-alert example-alert-revoke"
                                style={{ marginBottom: "15px" }}
                              >
                                <div className="alert alert-pro alert-danger">
                                  <div className="alert-text">
                                    <h4>Error</h4>
                                    <p>{this.state.clientErrorMessage}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.clientSuccessMessage !== "" ? (
                            <div className="col-md-12 mb-3">
                              <div
                                className="example-alert example-alert-revoke"
                                style={{ marginBottom: "15px" }}
                              >
                                <div className="alert alert-pro alert-success">
                                  <div className="alert-text">
                                    <h4>Success</h4>
                                    <p>{this.state.clientSuccessMessage}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          <div className="col-md-6">
                            <div className="form-group">
                              <div className="form-control-group">
                                <MutextField
                                  required
                                  id="client_name"
                                  name="client_name"
                                  type="text"
                                  label="Full Name"
                                  defaultValue={this.state.client_name}
                                  inputProps={{ maxLength: 64 }}
                                  onInput={(e) => {
                                    e.target.value = e.target.value.replace(
                                      /[^a-zA-Z\s'.,:\-()|!@]/gi,
                                      ""
                                    );
                                  }}
                                  helperText="Full name of the invite recipient."
                                  onChange={this.handleChange}
                                  variant="outlined"
                                  fullWidth
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <div className="form-control-group">
                                <MutextField
                                  required
                                  id="client_email"
                                  name="client_email"
                                  type="text"
                                  label="Email Address"
                                  defaultValue={this.state.client_email}
                                  helperText="Email address of the invite recipient."
                                  inputProps={{ maxLength: 30 }}
                                  onChange={this.handleChange}
                                  variant="outlined"
                                  fullWidth
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <div className="form-control-group">
                                <TextareaAutosize
                                  maxrows={4}
                                  name="invitation_comment"
                                  id="invitation_comment"
                                  aria-label=""
                                  placeholder="Add Comment *"
                                  inputProps={{ maxLength: 500 }}
                                  //maxLength={500}
                                  value={this.state.invitation_comment}
                                  helperText="Maximum 500 characters"
                                  onChange={this.handleChange}
                                  style={{
                                    width: "100%",
                                    height: "100px",
                                    borderColor: "rgba(0, 0, 0, 0.125)",
                                    borderRadius: "4px",
                                    padding: "5px",
                                  }}
                                  variant="outlined"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-12 d-flex justify-content-end">
                            <button
                              type="button"
                              onClick={() => this.saveNewClient()}
                              className="btn btn-primary"
                              disabled={this.state.disabled}
                            >
                              <span>Send Invite</span>{" "}
                              <em className="icon ni ni-emails"></em>
                            </button>
                          </div>
                          <div className="col-md-12">
                            <div className="example-alert">
                              <div className="alert alert-light">
                                <ul className="list">
                                  <li>
                                    An email will be dispatched to the provided
                                    email address.
                                  </li>
                                  <li>
                                    This email will contain a secure, tokenized
                                    link for sub-user registration.
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* New Client Modal End */}
              {/* Resend Invitation Modal Start */}
              <div
                className="modal fade"
                tabIndex="-1"
                id="modalresendInvitation"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    {this.state.clientInviteSuccessMessage && (
                      <>
                        <a
                          style={{ cursor: "pointer" }}
                          className="close"
                          onClick={() => {
                            this.modalHideResend();
                          }}
                        >
                          <em className="icon ni ni-cross"></em>
                        </a>
                        <div className="modal-body modal-body-lg text-center">
                          <div className="nk-modal">
                            <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-check bg-success"></em>
                            <h4
                              className="nk-modal-title"
                              style={{ fontSize: "1.3rem" }}
                            >
                              {this.state.clientInviteSuccessMessage}
                            </h4>
                          </div>
                        </div>
                      </>
                    )}
                    {this.state.clientInviteErrorMessage && (
                      <>
                        <a
                          style={{ cursor: "pointer" }}
                          className="close"
                          onClick={() => {
                            this.modalHideResend();
                          }}
                        >
                          <em className="icon ni ni-cross"></em>
                        </a>
                        <div className="modal-body modal-body-lg text-center">
                          <div className="nk-modal">
                            <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></em>
                            <h4
                              className="nk-modal-title"
                              style={{ fontSize: "1.3rem" }}
                            >
                              {this.state.clientInviteErrorMessage}
                            </h4>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
              {/* Resend Invitation Modal Ends */}
              {/* Modal Invitation Comment */}
              <div className="modal fade" tabIndex="-1" id="modalInvitationComment">
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">Invitation Comments</h5>
                    </div>
                    <div className="modal-body">
                      <p className="text-dark">
                        {this.state.invitation_comment &&
                        this.state.invitation_comment !== ""
                          ? this.state.invitation_comment
                          : "No Comments"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Modal Invitation Comment */}
              {/* MODAL Delete Client START */}
              <div className="modal fade" tabIndex="-1" id="modalDeleteAlert">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <a
                      style={{ cursor: "pointer" }}
                      className="close"
                      onClick={() => {
                        this.modalHideDel();
                      }}
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>
                        <h4 className="nk-modal-title">
                          Delete Invited Sub Client?
                        </h4>
                        {this.state.clientInviteErrorMessage !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-danger">
                              <div className="alert-text">
                                <h4>Error</h4>
                                <p>{this.state.clientInviteErrorMessage}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {this.state.clientInviteSuccessMessage !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-success">
                              <div className="alert-text">
                                <h4>Success</h4>
                                <p>{this.state.clientInviteSuccessMessage}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        <div className="nk-modal-text">
                          <div className="caption-text">
                            Are you sure you want to delete this Invited Sub
                            Client?
                          </div>
                        </div>
                        <div className="nk-modal-action">
                          <a
                            style={{ cursor: "pointer", color: "white" }}
                            className="btn btn-lg btn-mw btn-primary"
                            onClick={() => {
                              this.modalHideDel();
                            }}
                          >
                            CANCEL
                          </a>
                          {"  "}
                          <button
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-danger"
                            onClick={() => {
                              this.deleteInviteClient();
                            }}
                            disabled={this.state.disabled}
                          >
                            DELETE
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* MODAL Delete Client End */}
              {/* EDIT MODAL START */}
              <div className="modal fade" tabIndex="-1" id="modalFormDetail">
                <div className="modal-dialog modal-xl" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">
                        {" "}
                        <em className="icon ni ni-edit"></em> Edit Sub User
                      </h5>
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>

                    <div className="modal-body">
                      {/* Error Start */}
                      {this.state.errorMessageEdit !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "20px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: this.state.errorMessageEdit,
                                }}
                              ></p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessageEdit !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "20px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessageEdit}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <br />
                      <div className="row g-4">
                        <form method="post" autoComplete="off" encType="multipart/form-data">
                          <div className="row g-4">
                            <div className="form-group col-md-6">
                              <MutextField
                                required
                                id="client_name"
                                name="client_name"
                                type="text"
                                label="Sub User Name"
                                inputProps={{ maxLength: 30 }}
                                value={this.state.client_name}
                                onChange={this.handleChange}
                                helperText="Enter the name. Allowed characters: (&nbsp; ' &nbsp; - &nbsp; . &nbsp; , &nbsp; : &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                                variant="outlined"
                                fullWidth
                                error={this.state.errorName === "error"}
                              />
                            </div>

                            <div className="form-group col-md-3">
                              <MutextField
                                id="client_title"
                                name="client_title"
                                type="text"
                                inputProps={{ maxLength: 30 }}
                                label="Title"
                                value={this.state.client_title}
                                onChange={this.handleChange}
                                helperText="Enter the title. Allowed characters: (&nbsp; _ &nbsp; - &nbsp; . &nbsp; &amp; &nbsp; , &nbsp; : &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                                variant="outlined"
                                fullWidth
                              />
                            </div>

                            {this.state.role_field_enabled ? (
                              <div className="form-group col-md-3">
                                <MutextField
                                  id="client_role"
                                  name="client_role"
                                  type="text"
                                  inputProps={{ maxLength: 30 }}
                                  label="Role"
                                  value={this.state.client_role}
                                  onChange={this.handleChange}
                                  variant="outlined"
                                  fullWidth
                                />
                              </div>
                            ) : null}

                            <div className="form-group col-md-3">
                              <MutextField
                                required
                                id="client_comp"
                                name="client_comp"
                                type="text"
                                inputProps={{ maxLength: 100 }}
                                label="Company Name"
                                value={this.state.client_comp}
                                onChange={this.handleChange}
                                helperText="Enter the company name. Allowed characters: (&nbsp; _ &nbsp; . &nbsp; - &nbsp; , &nbsp; : &nbsp; &amp; &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                                variant="outlined"
                                fullWidth
                                error={
                                  this.state.errorClientCompany === "error"
                                }
                              />
                            </div>
                            <div className="form-group col-md-6">
                              <MutextField
                                required
                                id="client_email"
                                name="client_email"
                                type="email"
                                label="Email Address"
                                value={this.state.client_email}
                                onChange={this.handleChange}
                                helperText="Please note that the email address provided is read-only."
                                variant="outlined"
                                disabled
                                InputProps={{
                                  readOnly: true,
                                }}
                                fullWidth
                              />
                            </div>

                            <div className="form-group col-md-6">
                              <ReactPhoneInput
                                country="us"
                                value={this.state.client_phone}
                                onChange={(value) =>
                                  this.handleChange({
                                    target: {
                                      name: "client_phone",
                                      value: `+${value}`,
                                    },
                                  })
                                }
                                inputProps={{
                                  name: "client_phone",
                                  required: true,
                                  id: "client_phone",
                                  maxLength: 20,
                                  label: "Sub User Phone Number",
                                }}
                                specialLabel="Sub user phone number *"
                                containerStyle={{ width: "100%" }}
                                inputStyle={{ width: "100%", height: "56px" }}
                                isValid={this.state.errorClientPhone !== "error"}
                              />
                            </div>

                            <div className="form-group col-md-6 mt-md-0 googleLocation-autocomplete-wrapper">
                              <div
                                className="nk-block-between-md g-4"
                                style={{
                                  position: "absolute",
                                  zIndex: 9999,
                                  right: "13px",
                                  top: "-15px",
                                }}
                              >
                                {/* <div className="nk-block-head-content"></div> */}
                                {this.state.address_autocomplete === "Yes" && (
                                  <div className="nk-block-head-content">
                                    <ul className="nk-block-tools gx-3">
                                      <li>
                                        <a
                                          onClick={this.handleToggle}
                                          className="text-primary fs-11"
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "11px",
                                          }}
                                        >
                                          {toggleButtonText}
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                )}
                              </div>
                              <div>
                                {this.state.address_autocomplete === "Yes" ? (
                                  useGooglePlaces ? (
                                    <>
                                      <GooglePlacesAutocomplete
                                        apiKey={
                                          process.env
                                            .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                                        }
                                        selectProps={{
                                          value: this.state.client_address
                                            ? {
                                                label:
                                                  this.state.client_address,
                                                value:
                                                  this.state.client_address,
                                              }
                                            : null,
                                          onChange: this.handleAddressSelect,
                                          placeholder: this.state.client_address
                                            ? null
                                            : "Enter your address *",
                                          styles: {
                                            control: (provided) => ({
                                              ...provided,
                                              minHeight: "56px",
                                            }),
                                            menu: (provided) => ({
                                              ...provided,
                                              zIndex: "9",
                                            }),
                                          },
                                        }}
                                        id="googleLocation-autocomplete"
                                      />
                                    </>
                                  ) : (
                                    <MutextField
                                      required
                                      id="client_address"
                                      name="client_address"
                                      type="text"
                                      label="PO Box Address *"
                                      value={this.state.client_address}
                                      onChange={this.handleChange}
                                      helperText="Enter valid PO Box Address. i.e, PO Box Number, City, State Zip Code"
                                      variant="outlined"
                                      fullWidth
                                      InputLabelProps={{
                                        shrink: true,
                                        required: false,
                                      }}
                                      inputProps={{ maxLength: 100 }}
                                    />
                                  )
                                ) : (
                                  // address_autocomplete === "No" → show PO Box only
                                  <MutextField
                                    required
                                    id="client_address"
                                    name="client_address"
                                    type="text"
                                    label="Address"
                                    value={this.state.client_address}
                                    onChange={this.handleChange}
                                    helperText="Enter your address"
                                    variant="outlined"
                                    fullWidth
                                    InputLabelProps={{
                                      shrink: true,
                                      required: false,
                                    }}
                                  />
                                )}
                              </div>
                            </div>

                            <div className="form-group col-md-6">
                              <MutextField
                                id="client_address2"
                                name="client_address2"
                                type="text"
                                inputProps={{ maxLength: 100 }}
                                label="Address2"
                                value={this.state.client_address2}
                                onChange={this.handleChange}
                                helperText="Enter the address2 here."
                                variant="outlined"
                                fullWidth
                              />
                            </div>

                            <div className="form-group col-md-3">
                              <MutextField
                                required
                                id="client_city"
                                name="client_city"
                                type="text"
                                inputProps={{ maxLength: 30 }}
                                label="City"
                                value={this.state.client_city}
                                onChange={this.handleChange}
                                helperText="Enter the city here."
                                variant="outlined"
                                fullWidth
                                error={this.state.errorClientCity === "error"}
                              />
                            </div>

                            <div className="form-group col-md-3">
                              <MutextField
                                required
                                id="client_state"
                                name="client_state"
                                type="text"
                                inputProps={{ maxLength: 30 }}
                                label="State"
                                value={this.state.client_state}
                                onChange={this.handleChange}
                                helperText="Enter the state here."
                                variant="outlined"
                                fullWidth
                                error={this.state.errorClientState === "error"}
                              />
                            </div>

                            <div className="form-group col-md-3">
                              <MutextField
                                required
                                id="client_zip"
                                name="client_zip"
                                type="text"
                                inputProps={{ maxLength: 30 }}
                                label="zip"
                                value={this.state.client_zip}
                                onChange={this.handleChange}
                                helperText="Enter the zip here."
                                variant="outlined"
                                fullWidth
                                error={this.state.errorClientZip === "error"}
                              />
                            </div>

                            <div className="form-group col-md-3">
                              <Autocomplete
                                options={this.countryOptions}
                                getOptionLabel={(option) => option.label}
                                value={
                                this.state.client_country
                                  ? this.countryOptions.find(
                                      (opt) =>
                                        opt.label === this.state.client_country ||
                                        opt.value === this.state.client_country,
                                    ) || null
                                  : null
                              }
                                onChange={(event, newValue) =>
                                  this.handleChangeCountry(newValue || { label: "" })
                                }
                                renderInput={(params) => (
                                  <MutextField
                                    {...params}
                                    required
                                    label="Country"
                                    variant="outlined"
                                    fullWidth
                                    error={this.state.errorClientCountry === "error"}
                                    helperText="Select country"
                                  />
                                )}
                              />
                            </div>

                            {/* Keep Password & Confirm Password side by side regardless of the
                                optional Role field shifting the grid. */}
                            <div className="w-100"></div>
                            <div
                              className="form-group col-md-6"
                              style={{ position: "relative" }}
                            >
                              <MutextField
                                required
                                id="client_password"
                                name="client_password"
                                type={
                                  this.state.passwordShown ? "text" : "password"
                                }
                                label="Password"
                                value={this.state.client_password}
                                inputProps={{ maxLength: 30 }}
                                onChange={this.handleChange}
                                helperText="Password must be at least 8 characters, with
                                uppercase, lowercase, number & special
                                character."
                                variant="outlined"
                                fullWidth
                                error={
                                  this.state.errorClientPassword === "error"
                                }
                              />
                              <a
                                style={{
                                  left: "auto",
                                  right: "10px",
                                  top: "44px",
                                  position: "absolute",
                                  cursor: "pointer",
                                }}
                                tabIndex="-1"
                                onClick={this.togglePassword}
                                className="form-icon form-icon-right passcode-switch"
                                data-target="password"
                              >
                                {this.state.passwordShown ? (
                                  <em className="icon ni ni-eye-off"></em>
                                ) : (
                                  <em className="icon ni ni-eye"></em>
                                )}
                              </a>
                              <div>
                                <PasswordStrengthBar
                                  password={this.state.client_password}
                                />
                              </div>
                            </div>
                            <div
                              className="form-group col-md-6"
                              style={{ position: "relative" }}
                            >
                              <MutextField
                                required
                                id="client_c_password"
                                name="client_c_password"
                                type={
                                  this.state.confirmPasswordShown
                                    ? "text"
                                    : "password"
                                }
                                label="Confirm Password"
                                value={this.state.client_c_password}
                                inputProps={{ maxLength: 30 }}
                                onChange={this.handleChange}
                                helperText="Confirm Password must be at least 8 characters,
                                with uppercase, lowercase, number & special
                                character. Confirm Password must match the
                                Password."
                                variant="outlined"
                                fullWidth
                                error={this.state.errorCPassword === "error"}
                              />
                              <a
                                style={{
                                  left: "auto",
                                  right: "10px",
                                  top: "44px",
                                  position: "absolute",
                                  cursor: "pointer",
                                }}
                                tabIndex="-1"
                                onClick={() => {
                                  this.toggleConfirmPassword();
                                }}
                                className="form-icon form-icon-right passcode-switch"
                                data-target="password"
                              >
                                {this.state.confirmPasswordShown ? (
                                  <em className="icon ni ni-eye-off"></em>
                                ) : (
                                  <em className="icon ni ni-eye"></em>
                                )}
                              </a>
                            </div>

                            <div className="form-group col-md-6">
                              <MutextField
                                name="client_status"
                                select
                                label="Status *"
                                value={this.state.client_status}
                                onChange={this.handleChange}
                                SelectProps={{
                                  native: true,
                                }}
                                helperText=""
                                variant="outlined"
                                fullWidth
                              >
                                <option key="st1" value="active">
                                  Active
                                </option>
                                <option key="st2" value="inactive">
                                  Inactive
                                </option>
                              </MutextField>
                            </div>

                            {this.state.va_integration === "Yes" &&
                            this.state.client_integration === "enable" ? (
                              <div className="form-group col-md-6">
                                <MutextField
                                  name="client_integration"
                                  select
                                  label="VoiceAlerts Integration"
                                  value={this.state.client_integration}
                                  onChange={this.handleChange}
                                  SelectProps={{
                                    native: true,
                                  }}
                                  helperText=""
                                  variant="outlined"
                                  fullWidth
                                >
                                  <option key="st1" value="enable">
                                    Enable
                                  </option>
                                  <option key="st2" value="disable">
                                    Disable
                                  </option>
                                </MutextField>
                              </div>
                            ) : null}

                            <div
                              className="custom-control custom-control-lg custom-checkbox col-lg-3"
                              style={{ padding: 0, marginLeft: "3rem" }}
                            >
                              <div className="form-group">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  id="customCheck2"
                                  checked={this.state.notifyCheckBox}
                                  onChange={() => {
                                    const isChecked =
                                      !this.state.notifyCheckBox;
                                    this.setState({
                                      notifyCheckBox: isChecked,
                                    });
                                    // console.log(
                                    //   "Notify Checkbox Checked:",
                                    //   isChecked
                                    // );
                                  }}
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="customCheck2"
                                >
                                  Notify Sub User
                                </label>
                              </div>
                            </div>

                            <div className="form-group text-right col-md-12">
                              <button
                                className="btn btn-lg btn-primary"
                                type="button"
                                disabled={this.state.disabled}
                                onClick={this.formUpdateSubmit}
                              >
                                Submit
                              </button>
                            </div>
                            {/* <div className="example-alert border-top">
                              <div className="alert alert-light alert-icon">
                                <em className="icon ni ni-alert-circle"></em>{" "}
                                <ul className="list">
                                  <li>
                                    Please note that the email address provided
                                    is read-only. It cannot be modified or
                                    changed. If you need to update your email
                                    address, please contact our support team for
                                    assistance.
                                  </li>
                                  <li>
                                    To ensure the security of your account,
                                    please ensure that the password and confirm
                                    password fields match. The values entered in
                                    both fields must be identical for successful
                                    submission.
                                  </li>
                                </ul>
                              </div>
                            </div> */}
                          </div>
                        </form>
                      </div>

                      {/* </form> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* EDIT MODAL End */}
              {/* RIGHTS MODAL START */}
              <div className="modal fade" tabIndex="-1" id="modalFormRights">
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">
                        {" "}
                        <em className="icon ni ni-unlock"></em> Sub User Rights
                      </h5>
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>

                    <div className="modal-body">
                      {/* Error Start */}
                      {this.state.errorMessageRights !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "20px" }}
                        >
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p>{this.state.errorMessageRights}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessageRights !== "" ? (
                        <div
                          className="example-alert"
                          style={{ marginBottom: "20px" }}
                        >
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessageRights}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}

                      <div className=" g-4">
                        {this.state.tableLoaderListing === true ? (
                          tableLoaderListing()
                        ) : (
                          <>
                            <div id="no-more-tables-new">
                              <p>
                                These permissions allow users to access and view
                                information, data, or content within the system.
                              </p>
                              <table className="table table-bordered">
                                <thead className="thead-light">
                                  <tr>
                                    <th className="tb-col-os">
                                      <span className="overline-title">
                                        Main Menu
                                      </span>
                                    </th>
                                    <th className="tb-col-ip">
                                      <span className="overline-title">
                                        Sub Menu
                                      </span>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.allRights &&
                                  this.state.allRights.length > 0 ? (
                                    <>
                                      {this.state.allRights.map(
                                        (mainRights, i) => (
                                          <tr key={`menu${i}`}>
                                            <td className="tb-col-os">
                                              <div className="custom-control custom-control custom-checkbox align-switch-div">
                                                <input
                                                  type="checkbox"
                                                  className="custom-control-input vdrSelected"
                                                  id={`cp-main-menu${i}`}
                                                  name="main_menu_id"
                                                  defaultChecked={
                                                    this.state
                                                      .assignedMainRights &&
                                                    this.state
                                                      .assignedMainRights
                                                      .length > 0
                                                      ? this.state.assignedMainRights.includes(
                                                          mainRights.link_id
                                                        )
                                                      : null
                                                  }
                                                  value={mainRights.link_id}
                                                  onChange={this.handleChange}
                                                  required=""
                                                />
                                                <label
                                                  className="custom-control-label"
                                                  htmlFor={`cp-main-menu${i}`}
                                                >
                                                  {mainRights.alt}
                                                </label>
                                              </div>
                                            </td>
                                            <td className="tb-col-ip">
                                              {mainRights.submenu &&
                                              mainRights.submenu.length > 0 ? (
                                                <>
                                                  {mainRights.submenu.map(
                                                    (subRights, index) => (
                                                      <div
                                                        className="col-md-6 col-lg-6 mb-2 inner_column"
                                                        key={`submenu${index}`}
                                                      >
                                                        <div className="custom-control custom-control custom-checkbox align-switch-div">
                                                          <input
                                                            type="checkbox"
                                                            className={`custom-control-input vdrSelectedSub${mainRights.link_id}`}
                                                            id={`cp-sub-menu${index}`}
                                                            name="sub_menu_id"
                                                            defaultChecked={
                                                              this.state
                                                                .assignedSubRights &&
                                                              this.state
                                                                .assignedSubRights
                                                                .length > 0
                                                                ? this.state.assignedSubRights.includes(
                                                                    subRights.link_id
                                                                  )
                                                                : null
                                                            }
                                                            value={
                                                              subRights.link_id
                                                            }
                                                            onChange={
                                                              this.handleChange
                                                            }
                                                            required=""
                                                          />
                                                          <label
                                                            className="custom-control-label"
                                                            htmlFor={`cp-sub-menu${index}`}
                                                          >
                                                            {subRights.alt}
                                                          </label>
                                                        </div>
                                                      </div>
                                                    )
                                                  )}
                                                </>
                                              ) : null}
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </>
                                  ) : null}
                                </tbody>
                              </table>
                            </div>
                            <div className="nk-kycfm-action m-3 text-right">
                              <button
                                type="button"
                                className="btn btn-lg btn-primary"
                                disabled={this.state.disabled}
                                onClick={this.formSaveRights}
                              >
                                <em className="icon ni ni-plus-round"></em>
                                Save Rights
                              </button>
                            </div>
                          </>
                        )}
                      </div>

                      {/* </form> */}
                    </div>
                  </div>
                </div>
              </div>
              {/* RIGHTS MODAL End */}
              {/* Role Sub Client Assignment Modal START */}
              <div
                className="modal fade"
                tabIndex="-1"
                id="modalSubClientAssignRole"
              >
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <div
                        className="modal-title"
                        style={{ textAlign: "center", fontSize: "20px" }}
                      >
                        <strong>
                          <em className="icon ni ni-grid-alt"></em>Sub User Roles{" "}
                          <sup>
                            <small className="text-soft d-none d-sm-inline">
                              {this.state.rolesSubClientName}
                            </small>
                          </sup>
                        </strong>
                      </div>
                      <a
                        href="#"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <em className="icon ni ni-cross"></em>
                      </a>
                    </div>

                    <div className="modal-body text-left">
                      <div className="nk-modal">
                        <div className="nk-modal-text">
                          {this.state.subclientRoleLoader === true ? (
                            tableLoader()
                          ) : (
                            <>
                              {this.state.errorMessageSubClientRole !== "" ? (
                                <div
                                  className="example-alert "
                                  style={{ marginBottom: "15px" }}
                                >
                                  <div className="alert alert-pro alert-danger">
                                    <div className="alert-text">
                                      <h4>Error</h4>
                                      <p>
                                        {this.state.errorMessageSubClientRole}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              ) : null}
                              {this.state.successMessageSubClientRole !== "" ? (
                                <div
                                  className="example-alert "
                                  style={{ marginBottom: "15px" }}
                                >
                                  <div className="alert alert-pro alert-success">
                                    <div className="alert-text">
                                      <h4>Success</h4>
                                      <p>
                                        {this.state.successMessageSubClientRole}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              ) : null}

                              <div className="card card-bordered card-preview">
                                <div className="table-responsive">
                                  <table className="table table-orders" style={{ minWidth: "600px" }}>
                                    <thead className="tb-odr-head">
                                      <tr className="tb-odr-item">
                                        <th
                                          width="35%"
                                          style={{
                                            borderRight: "1px solid #dbdfea",
                                          }}
                                        >
                                          <span className="tb-odr-action">
                                            Roles
                                          </span>
                                        </th>
                                        <th width="65%">
                                          <span className="tb-odr-action">
                                            Sub Roles
                                          </span>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody className="tb-odr-body">
                                      {this.state.allRoleData &&
                                      this.state.allRoleData.length > 0 ? (
                                        <>
                                          {this.state.allRoleData.map(
                                            (role, index) => (
                                              <tr
                                                className="tb-odr-item"
                                                key={`role${index}`}
                                              >
                                                <td
                                                  style={{
                                                    borderRight:
                                                      "1px solid #dbdfea",
                                                  }}
                                                >
                                                  <FormControlLabel
                                                    control={
                                                      <Checkbox
                                                        checked={this.state.allRoleData.some(
                                                          (item) =>
                                                            item.alt ===
                                                              role.alt &&
                                                            item.isChecked
                                                        )}
                                                        onChange={
                                                          this
                                                            .changedAllRolesRights
                                                        }
                                                        disabled={
                                                          role.parent_role_id ===
                                                          1
                                                        }
                                                        name={role.id.toString()}
                                                        id={`role-${role.parent_role_id}`}
                                                        color="primary"
                                                      />
                                                    }
                                                    style={{
                                                      marginBottom: "0px",
                                                    }}
                                                    label={role.alt}
                                                  />
                                                </td>
                                                <td
                                                  className="d-flex flex-wrap gap-2 pl-4"
                                                >
                                                  {this.state.allSubRoleData
                                                    .filter((subRole) => {
                                                      return (
                                                        subRole.role_id ===
                                                        role.id
                                                      );
                                                    })
                                                    .map((subRole, subIndex) => (
                                                      <div
                                                        key={`subRole${subIndex}`}
                                                      >
                                                        <FormControlLabel
                                                          control={
                                                            <Checkbox
                                                              checked={this.state.allSubRoleData.some(
                                                                (item) =>
                                                                  item.alt ===
                                                                    subRole.alt &&
                                                                  item.isChecked
                                                              )}
                                                              onChange={
                                                                this
                                                                  .changedAllSubRolesRights
                                                              }
                                                              name={subRole?.tabdetailid?.toString()}
                                                              color="primary"
                                                            />
                                                          }
                                                          style={{
                                                            marginBottom: "0px",
                                                          }}
                                                          label={subRole.alt}
                                                        />
                                                      </div>
                                                    ))}
                                                </td>
                                              </tr>
                                            )
                                          )}
                                        </>
                                      ) : null}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              <div className="nk-modal-action  text-right">
                                <button
                                  href="#"
                                  className="btn btn-lg btn-mw btn-primary "
                                  onClick={(e) => {
                                    e.preventDefault();
                                    this.handleSubmitRoleCheckboxSub(
                                      this.state.checkedName,
                                      this.state.checkedEmail
                                    );
                                  }}
                                  disabled={this.state.subdisableRoleBtn}
                                >
                                  Assign Roles
                                </button>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Role Sub Client Assignment Modal End */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SubClients);
